import MobileNestedMenu from '../../../components/Modals/FullScreenModal/MobileNestedMenu';
import useToggle from 'academy-common-lib/hooks/useToggle';
import { MenuRow } from '../../cardMenu/components/MobileCardMenu';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useMyPlaylistsParams } from '../myPlaylistsHooks';
import { MY_PLAYLISTS_TABS } from '../myPlaylistsTypes';
import PanelSection from '../../../components/Modals/FullScreenModal/PanelSection';
import useNavigate from '../../../hooks/useNavigate';
import { getMyPlaylistsUrl } from '../myPlaylistsRouting';
import { Flex } from 'foundations-components/components/Flex';
import { Button } from 'foundations-components/transitional/components/Button';
import { DownCaratIcon } from 'foundations-assets/icons/components/DownCaratIcon';
import { Spacer } from 'foundations-components/components/Spacer';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const MyPlaylistsTabNavigationMobile = () => {
  const {
    isShowing,
    show,
    hide,
    toggle
  } = useToggle();
  const {
    tab: selectedTab
  } = useMyPlaylistsParams();
  const navigate = useNavigate();
  const handleOnClick = tab => {
    hide();
    navigate(getMyPlaylistsUrl({
      tab
    }));
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Button, {
      onClick: show,
      responsive: false,
      use: "link",
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.topFilters.myPlaylistsType.${selectedTab}`
        }), /*#__PURE__*/_jsx(Spacer, {
          marginInlineStart: "100"
        }), /*#__PURE__*/_jsx(DownCaratIcon, {})]
      })
    }), isShowing && /*#__PURE__*/_jsxs(MobileNestedMenu, {
      indented: false,
      open: true,
      setIsOpen: toggle,
      useBackText: true,
      useSidePanel: true,
      children: [/*#__PURE__*/_jsx(PanelSection, {
        showBorders: false,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.topFilters.myPlaylistsType.filterTitle"
        })
      }), MY_PLAYLISTS_TABS.map(tab => /*#__PURE__*/_jsx(MenuRow, {
        children: /*#__PURE__*/_jsx(View, {
          onClick: () => handleOnClick(tab),
          children: /*#__PURE__*/_jsx(Text, {
            textAlign: "left",
            typography: tab === selectedTab ? 'body-125' : 'body-100',
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `learningCenter.topFilters.myPlaylistsType.${tab}`
            })
          })
        })
      }, tab))]
    })]
  });
};
export default MyPlaylistsTabNavigationMobile;